import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { JobMapComponent } from './job-map.component';

const routes: Routes = [{ path: 'job-map', component: JobMapComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class JobMapRoutingModule {}
